/* tslint:disable:variable-name */
import {ActionContext, ActionTree, MutationTree} from 'vuex'
import {AxiosError, AxiosResponse} from 'axios'

export class RegistrationRequest {
  [key: string]: any

  public client_token: string = '' //
  public client_type_id: string = '' //
  public name: string = '' //
  public surname: string = '' //
  public gender: string = '' //
  public phone: string = '' //
  public email: string = '' //
  public mobile: string = '' //
  public birthdate: string = '' //
  public fiscal_code: string = '' //
  public address: Address = new Address() //

  public vat_number: string = '' //
  public organization_name: string = '' //
  public billing_address: Address = new Address() //

  // public driver_license: DriverLicense = new DriverLicense()
  public extra: any = {}
  public accepted_tocs_id: string[] = []
}

export class Address {
  [key: string]: string

  public country: string = ''
  public region: string = ''
  public city: string = ''
  public postal_code: string = ''
  public street: string = ''
}

export class DriverLicense {
  [key: string]: string | string[]

  public license_type_id: string = ''
  public expiry: string = ''
  public issued_by: string = ''
  public issuer_country: string = ''
  public issued_date: string = ''
  public number: string = ''
  public attachments: string[] = []
}

class RegistrationState extends RegistrationRequest {
}

const state = new RegistrationRequest()

const mutations: MutationTree<RegistrationState> = {
  PURGE_REGISTRATION(stateR) {
    stateR.client_token = ''
    stateR.client_type_id = ''
    stateR.name = ''
    stateR.surname = ''
    stateR.gender = ''
    stateR.phone = ''
    stateR.email = ''
    stateR.mobile = ''
    stateR.birthdate = ''
    stateR.fiscal_code = ''
    stateR.vat_number = ''
    stateR.organization_name = ''
    stateR.address = new Address()
    stateR.billing_address = new Address()
  },
  UPDATE_REGISTRATION(stateR: RegistrationState, payload: RegistrationRequest) {
    for (const key of Object.keys(payload)) {
      if (stateR.hasOwnProperty(key)) {
        // @ts-ignore
        stateR[key] = payload[key]
      }
    }
  },
}

const actions: ActionTree<RegistrationState, any> = {
  purge(store: ActionContext<RegistrationState, any>) {
    store.commit('PURGE_REGISTRATION')
  },
  updateRegistration(store: ActionContext<RegistrationState, any>, payload: RegistrationState) {
    store.commit('UPDATE_REGISTRATION', payload)
    store.dispatch('sleep')
  },
  sendRegistration(store: ActionContext<any, any>) {
    return store.dispatch('registration', store.state).then((r: AxiosResponse) => {
      return r
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
